import { css } from 'lit';
export default css ` 
         @charset "UTF-8";
/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
:root,
:host {
  --size-base-unit: 0.5rem;
}

/**
 * RTL support for values logical properties can't automatically adjust for
 * 1) Percentage based horizontal translate values need to be flipped
 * 2) Background gradients using "to right" or "to left" need to be switched to using deg values
 * 3) Background Position From is used for reversing animation from right to left at 0%
 * 4) Background Position To is used for reversing animation from right to left at 100%
 * 5) Rotate Icon to 180deg for nav button
 * 6) Transformation size for badge left positions
 * 7) Transformation size for badge right positions
 * 8 to 18) Padding values for Input Field Type Tel
 */
[dir=rtl] {
  --rtlTranslateX: 50%; /* 1 */
  --rtlGradientToRight: 270deg; /* 2 */
  --rtlBackgroundPositionFrom: -135%; /* 3 */
  --rtlBackgroundPositionTo: 0%; /* 4 */
  --rtlRotate180: 180deg; /* 5 */
  --rtlRotate135: 135deg;
  --rtlBadgeLeft: -1.5; /* 6 */
  --rtlBadgeRight: 1.5; /* 7 */
  --rtlTelTypeInputFieldPaddingStart: calc(var(--size-base-unit) * 5); /* 8 */
  --rtlTelTypeInputFieldPaddingEnd: calc(var(--size-base-unit) * 2); /* 9 */
  --rtlTelTypeInputFieldMedPaddingStart: calc(var(--size-base-unit) * 4.5); /* 10 */
  --rtlTelTypeInputFieldMedPaddingEnd: calc(var(--size-base-unit) * 1.5); /* 11 */
  --rtlTelTypeInputFieldSmPaddingStart: calc(var(--size-base-unit) * 4); /* 12 */
  --rtlTelTypeInputFieldSmPaddingEnd: calc(var(--size-base-unit) * 1); /* 13 */
  --rtlTelTypeInputFieldCharBeforePaddingEnd: calc(var(--size-base-unit) * 3.75); /* 14 */
  --rtlTelTypeInputFieldCharAfterPaddingStart: calc(var(--size-base-unit) * 6); /* 15 */
  --rtlTelTypeInputFieldCharAfterErrPaddingStart: calc(var(--size-base-unit) * 9); /* 16 */
  --rtlTelTypeInputFieldIconAfterErrPaddingStart: calc(var(--size-base-unit) * 8); /* 17 */
  --rtlTelTypeInputFieldIconCharAfterErrPaddingStart: calc(var(--size-base-unit) * 12); /* 18 */
  --rtlDisplayNone: none;
  --rtlDisplayBlock: block;
  --rtlDrawerRightTranslateX: -100%;
  --rtlDrawerLeftTranslateX: 100%;
}

/**
 * Visible focus outline for elements on a light background
 */
/**
 * Visible focus outline for elements on a dark background
 */
/**
 * Invisible focus outline for elements that need a more visible
 * focus state for high-contrast mode
 */
/**
 * Visually hidden from display
 */
/**
 * style for text ellipsis
 */
/**
 * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
 */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */ /* ------------------------------------*\
    #FILE-UPLOAD
\*------------------------------------ */
/**
 * 1) Form field that consists of a label, text input, and field note
 */
/**
 * File upload label
 */
.cat-c-file-upload__label {
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
  display: block;
  margin-block-end: calc(var(--size-base-unit) * 1);
}

/**
   * File upload label text
   */
.cat-c-file-upload__label-text {
  margin-block-end: calc(var(--size-base-unit) * 1);
  /**
   * Hide label text
   */
}
.cat-c-file-upload--hidden-label .cat-c-file-upload__label-text {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/**
   * Dragging state
  */
.cat-is-dragging .cat-c-file-upload__body {
  background: var(--cat-theme-color-background-disabled);
  position: relative;
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  gap: calc(var(--size-base-unit) * 1);
  justify-content: center;
  text-align: center;
  outline: var(--cat-theme-border-width) dashed var(--cat-theme-color-border-default);
}

/**
 * Content inside of file upload area
 */
.cat-c-file-upload__body {
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
  position: relative;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  gap: calc(var(--size-base-unit) * 1);
  justify-content: center;
  padding: calc(var(--size-base-unit) * 2);
  text-align: center;
  outline: var(--cat-theme-border-width) dashed var(--cat-theme-color-border-default);
  /**
   * "Button" variant
   */
}
.cat-c-file-upload--button .cat-c-file-upload__body {
  font-family: var(--cat-theme-typography-label-font-family);
  font-weight: var(--cat-theme-typography-label-font-weight);
  font-size: var(--cat-theme-typography-label-font-size);
  line-height: var(--cat-theme-typography-label-line-height);
  display: flex;
  flex-flow: row nowrap;
  text-align: start;
  align-items: flex-start;
  hyphens: auto;
  color: var(--cat-theme-color-content-knockout);
  background-color: var(--cat-theme-color-button-contrast-background);
  min-height: var(--cat-line-height-40);
  outline: var(--cat-theme-border-width) solid var(--cat-theme-color-button-contrast-border);
  border-radius: var(--cat-theme-border-radius);
  padding: calc(var(--size-base-unit) * 1) calc(var(--size-base-unit) * 2);
}
.cat-c-file-upload--button.cat-c-file-upload--disabled .cat-c-file-upload__body {
  background-color: var(--cat-theme-color-background-default-disabled);
  outline: var(--cat-theme-border-width) solid var(--cat-theme-color-border-disabled);
  color: var(--cat-theme-color-content-disabled);
}
.cat-c-file-upload__body:has(.cat-c-file-upload__input:focus) {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, -2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
  outline-offset: calc(var(--size-base-unit) * -0.125);
}
.cat-c-file-upload__body:has(.cat-c-file-upload__input:focus-visible) {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, -2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-file-upload__body .cat-c-file-upload__description {
  display: flex;
  text-align: start;
  gap: calc(var(--size-base-unit) * 1);
}

.cat-c-file-upload--button .cat-c-file-upload__body:hover {
  background-color: var(--cat-theme-color-button-contrast-background-hover);
  border: 0;
}

.cat-c-file-upload--button.cat-c-file_upload_active .cat-c-file-upload__body {
  background-color: var(--cat-theme-color-button-contrast-background-active);
  border: 1px solid var(--cat-theme-color-button-contrast-border-active);
}
.cat-c-file-upload--button.cat-c-file_upload_active .cat-c-file-upload__body:has(.cat-c-file-upload__input:focus) {
  outline: none;
}

/**
 * Disabled state
 */
.cat-c-file-upload--disabled {
  cursor: not-allowed;
  color: var(--cat-theme-color-content-disabled);
  /**
  * Hiding table header in disabled state
  */
}
.cat-c-file-upload--disabled .cat-c-file-upload__list {
  color: var(--cat-theme-color-content-disabled);
}
.cat-c-file-upload--disabled .cat-c-file-upload__list .cat-c-file-upload__status--failed {
  color: var(--cat-theme-color-content-disabled);
}
.cat-c-file-upload--disabled .cat-c-file-upload__list .cat-c-file-upload__status--success {
  color: var(--cat-theme-color-content-disabled);
}
.cat-c-file-upload--disabled .cat-c-file-upload__list .cat-c-file-upload__close-button {
  --cat-icon-fill: var(--cat-theme-color-button-content-disabled);
}
.cat-c-file-upload--disabled .cat-c-file-upload__label {
  pointer-events: none;
}
.cat-c-file-upload--disabled .cat-c-file-upload__item.cat-c-file-upload__item-header {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/**
 * Disabled body & input
 */
.cat-c-file-upload--disabled .cat-c-file-upload__body,
.cat-c-file-upload--disabled .cat-c-file-upload__input {
  cursor: not-allowed;
}

/**
 * Disabled fieldnote
 */
cat-field-note {
  --cat-field-note-margin-block-start: 0;
  --cat-theme-color-content-brand: var(--cat-theme-color-content-subtle);
  line-height: var(--cat-line-height-16);
}
.cat-c-file-upload--disabled cat-field-note {
  --cat-theme-color-content-brand: var(--cat-theme-color-content-disabled);
}

.cat-file-upload-fieldNote {
  display: flex;
  --cat-theme-color-content-brand: var(--cat-theme-color-content-default);
}

/**
 * Slotted content that appears in the drop zone
 */
.cat-c-file-upload__body slot {
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
  align-items: center;
}

/**
 * Button styles
 */
.cat-file-upload-button,
::slotted(cat-button) {
  z-index: 2;
  --cat-theme-color-button-default-content: var(--cat-theme-color-content-knockout);
  --cat-theme-color-button-default-background: var(--cat-color-neutral-70);
  /**
   * Disabled button
   */
}
.cat-c-file-upload--disabled .cat-file-upload-button,
.cat-c-file-upload--disabled ::slotted(cat-button) {
  --cat-theme-color-button-content: var(--cat-theme-color-content-disabled);
  --cat-theme-color-button-background: var(--cat-theme-color-background-default-disabled);
  --cat-theme-color-button-border: var(--cat-theme-color-border-disabled);
}

cat-loading-indicator {
  display: block;
  margin-inline-end: calc(var(--size-base-unit) * 1);
}

/**
 * Optional upload icon
 */
.cat-file-upload-icon,
::slotted(cat-icon),
::slotted(.cat-icon) {
  --cat-icon-height: calc(var(--size-base-unit) * 2);
  --cat-icon-width: calc(var(--size-base-unit) * 2);
  /**
   * Button variant icon size
   */
  /**
   * Disabled icon
   */
}
.cat-c-file-upload--button .cat-file-upload-icon,
.cat-c-file-upload--button ::slotted(cat-icon),
.cat-c-file-upload--button ::slotted(.cat-icon) {
  --cat-icon-height: calc(var(--size-base-unit) * 2);
  --cat-icon-width: calc(var(--size-base-unit) * 2);
}
.cat-c-file-upload--disabled .cat-file-upload-icon,
.cat-c-file-upload--disabled ::slotted(cat-icon),
.cat-c-file-upload--disabled ::slotted(.cat-icon) {
  --cat-icon-fill: var(--cat-theme-color-button-content-disabled);
}

/**
 * File upload input
 */
.cat-c-file-upload__input {
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  border: none;
  z-index: 2;
  opacity: 0;
}

/**
 * File upload list
 */
.cat-c-file-upload__list {
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
  list-style: none;
  margin: calc(var(--size-base-unit) * 1) 0 0;
  padding: 0;
}

/**
 * Uploaded list item
 */
.cat-c-file-upload__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cat-c-file-upload__item-header {
  border-block-end: var(--cat-theme-border-width) solid var(--cat-theme-color-border-default);
}

/**
 * Uploaded list item headings
 */
.cat-c-file-upload__item cat-heading {
  font-family: var(--cat-theme-typography-label-font-family);
  font-weight: var(--cat-theme-typography-label-font-weight);
  font-size: var(--cat-theme-typography-label-font-size);
  line-height: var(--cat-theme-typography-label-line-height);
  --cat-font-size-16: var(--cat-font-size-14);
  margin-block-end: calc(var(--size-base-unit) * 0.5);
}

/**
 * Uploaded items first group heading
 */
h3.cat-c-file-upload__item-first {
  padding-inline-start: calc(var(--size-base-unit) * 1);
}

/**
 * Uploaded list item grouping
 */
.cat-c-file-upload__item-first {
  display: flex;
  padding: calc(var(--size-base-unit) * 0.75) calc(var(--size-base-unit) * 2);
  align-items: flex-start;
  flex: 1 0 0;
}

.cat-c-file-upload__item-second {
  display: flex;
  padding: calc(var(--size-base-unit) * 0.75) calc(var(--size-base-unit) * 2);
  align-items: center;
  gap: calc(var(--size-base-unit) * 1);
  flex: 1 0 0;
  overflow: hidden;
}

.cat-c-file-upload__item-third {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: calc(var(--size-base-unit) * 10.875);
}

.cat-c-file-upload__item-first__title,
.cat-c-file-upload__item-second__title,
.cat-c-file-upload__item-third__title {
  display: flex;
  padding: calc(var(--size-base-unit) * 0.5) calc(var(--size-base-unit) * 2);
  align-items: center;
  gap: calc(var(--size-base-unit) * 1);
  font-size: var(--cat-font-size-14);
  font-weight: var(--cat-font-weight-semibold);
  line-height: var(--cat-line-height-20);
  color: var(--cat-theme-color-content-default);
}

.cat-c-file-upload__item-first__title,
.cat-c-file-upload__item-second__title {
  flex: 1 0 0;
}

.cat-c-file-upload__item-third__title {
  justify-content: center;
  width: calc(var(--size-base-unit) * 10.875);
}

.cat-c-file-upload__list-small-table {
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
  list-style: none;
  margin: calc(var(--size-base-unit) * 1) 0 0;
  padding: 0;
}
.cat-c-file-upload__list-small-table .cat-c-file-upload__item-small-table {
  display: flex;
  align-items: center;
  padding: calc(var(--size-base-unit) * 2);
  width: calc(var(--size-base-unit) * 47.5);
  justify-content: space-between;
  outline: var(--cat-theme-border-width) solid var(--cat-theme-color-border-default);
  margin-block-end: calc(var(--size-base-unit) * 1);
}
.cat-c-file-upload__list-small-table .cat-c-file-upload__item-small-table .cat-c-file-upload__small-table .cat-c-file-upload__name-container {
  display: flex;
  align-items: center;
}
.cat-c-file-upload__list-small-table .cat-c-file-upload__item-small-table .cat-c-file-upload__item-second {
  margin-block-start: calc(var(--size-base-unit) * 1);
  padding: 0;
  width: unset;
}
.cat-c-file-upload__list-small-table .cat-c-file-upload__item-small-table .cat-c-file-upload__item-second .cat-c-file-upload__status-text {
  margin-inline-start: 3px;
}

.cat-c-drop_text {
  line-height: var(--cat-line-height-40);
}

/**
 * File name of uploaded item
 */
.cat-c-file-upload__item-text {
  word-break: break-all;
}

.cat-c-file-upload__small-table .cat-c-file-upload__name-container--remove {
  display: flex;
  align-items: center;
  color: var(--cat-theme-color-content-disabled);
}

/**
 * Upload status
 */
.cat-c-file-upload__status {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  /**
   * Status icon
   */
  /**
   * Status text in tabular format
   */
  /**
   * Success  
   */
  /**
   * Failed
   */
  /**
   * Removed
   */
}
.cat-c-file-upload__status cat-icon,
.cat-c-file-upload__status .cat-icon {
  --cat-icon-height: calc(var(--size-base-unit) * 2);
  --cat-icon-width: calc(var(--size-base-unit) * 2);
  margin-inline-end: calc(var(--size-base-unit) * 1);
}
@media all and (max-width: 48rem) {
  .cat-c-file-upload__status cat-icon,
  .cat-c-file-upload__status .cat-icon {
    margin-block-start: 3px;
  }
}
.cat-c-file-upload__status .cat-c-tabular-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cat-c-file-upload__status--success {
  color: var(--cat-theme-color-content-utility-success);
}
.cat-c-file-upload__status--failed {
  color: var(--cat-theme-color-content-utility-error);
}
.cat-c-file-upload__status--removed {
  color: var(--cat-color-neutral-60);
}

/**
 * Prefixed icon of uploaded item
 */
.cat-c-file-upload__icon {
  --cat-icon-width: calc(var(--size-base-unit) * 2);
  --cat-icon-height: calc(var(--size-base-unit) * 2);
  height: var(--cat-icon-height);
  width: var(--cat-icon-width);
  margin-inline-end: calc(var(--size-base-unit) * 1);
}

/**
 * File upload close button
 */
.cat-c-file-upload__close-button {
  --cat-icon-fill: var(--cat-color-utility-red);
  --cat-button-padding: calc(var(--size-base-unit) * 0.625) calc(var(--size-base-unit) * 2);
}
`;
